import {
  createCreateUseModal,
  Flex,
  PrimaryButton,
  RemoteImage,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import { Keyboard } from 'react-native';
import { useMemo } from 'react';
import { isWeb } from '../../utils';
import { getScreenWidth } from '../../utils/getScreenWidth/getScreenWidth';

const createAlertModal = createCreateUseModal({
  modalProps: {
    coverScreen: isWeb,
    style: {
      margin: 0,
      padding: 0,
      justifyContent: 'center',
    },
    deviceWidth: isWeb ? getScreenWidth() : undefined,
    animationIn: 'fadeIn',
    animationOut: 'fadeOut',

    backdropTransitionOutTiming: 10,
    onBackButtonPress() {
      Keyboard?.dismiss();
    },
    onBackdropPress() {
      Keyboard?.dismiss();
    },
  },
  cancelOnBackButtonPress: true,
  cancelOnBackdropPress: true,
});

const HORIZONTAL_MARGIN = 32;
const HORIZONTAL_PADDING = 32;

export const useMemberSignupRequestModal = createAlertModal<
  void,
  { title: string; description: string }
>(({ confirm, param }) => {
  const { width: screenWidth } = useScreenSize();
  const imageWidth = useMemo(
    () => screenWidth - HORIZONTAL_PADDING * 2,
    [screenWidth],
  );

  return (
    <Flex.Row
      alignItems={'center'}
      justifyContent={'center'}
      padding={{ horizontal: HORIZONTAL_MARGIN }}
    >
      <Flex
        backgroundColor={'white'}
        borderRadius={12}
        width={screenWidth - HORIZONTAL_MARGIN}
        padding={{
          top: 24,
          bottom: 16,
          horizontal: HORIZONTAL_PADDING * 0.5,
        }}
      >
        <Flex gap={4} alignItems={'center'}>
          {param.title.length > 0 && (
            <Typography type={'body1-relaxed'} color={'content_tertiary'}>
              {param.title}
            </Typography>
          )}
          {param.description.length > 0 && (
            <Typography type={'h4'} textAlign={'center'}>
              {param.description}
            </Typography>
          )}
        </Flex>

        <Flex margin={{ vertical: 20 }} alignItems={'center'}>
          <RemoteImage
            uri={
              'https://img.a-bly.com/promotions/first_purchase/anonymous_dialog_image.png'
            }
            width={imageWidth}
            height={imageWidth * (480 / 837)}
          />
        </Flex>
        <PrimaryButton variant={'fill'} onPress={confirm}>
          5초만에 회원가입 / 로그인
        </PrimaryButton>
      </Flex>
    </Flex.Row>
  );
});
